import { Link } from 'react-router-dom';
import { t } from '@app/i18n';
import { Badge } from '@zarya/ui';
import type { Environment } from '../TenantSettings/TenantSettingsModel';
import { useEnvironmentApprovalRules } from './ApprovalWorkflow.api';
import { approvalSummary, workflowLink } from './ApprovalWorkflowModel';

export function EnvironmentApprovalSummary({ environment }: { environment: Environment }) {
  const query = useEnvironmentApprovalRules(environment.id, environment.selectable_for_identity);
  const summary = !environment.selectable_for_identity
    ? 'notSelectable'
    : query.isError
      ? 'unavailable'
      : !query.data
        ? 'loading'
        : approvalSummary(query.data.rules);
  return (
    <Link
      to={workflowLink(environment.id)}
      aria-label={t('approvalWorkflow.configure', { name: environment.name })}
    >
      <Badge tone={summary === 'automatic' ? 'primary' : 'neutral'}>
        {t(`tenantSettings.environments.approval.${summary}`)}
      </Badge>
    </Link>
  );
}
